/**
 * The EditorFormSection component
 */
import React, { Component } from "react";
import {
  Badge,
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from "reactstrap";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import DataLayerHelper from "../../utils/dataLayer";

/**
 * Stateless react component to render the EditorFormSection page
 * @param {Object} props the props passed to the page.
 */
class EditorFormSection extends Component {
  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);
    this.state = {
      helpModalOpen: false,
    };
  }

  toggleModal() {
    this.setState({
      helpModalOpen: !this.state.helpModalOpen,
    });
    if (this.state.helpModalOpen) {
      DataLayerHelper.addEventWithOrigin(
        "behaviour",
        "editor",
        "openHelp",
        `${this.props.panelName} - ${this.props.panelTitle}`
      );
    }
  }

  render() {
    const { toggle, panelName, panelTitle, open, keepOpen, help } =
      this.props;
    return (
      <div className="editorformsection">
        <div className="editorformsection__header d-flex">
          <div
            onClick={toggle ? toggle.bind(this, panelName) : undefined}
            className={classNames(
              "editorformsection__header__title",
              "flex-grow-1",
              { keepOpen: keepOpen }
            )}
          >
            <h2 className="mb-0 font-weight-bold">
              {!keepOpen && open && <FaChevronDown />}
              {!keepOpen && !open && <FaChevronRight />}
              {panelTitle}
            </h2>
          </div>
          {help && (
            <div className="editorformsection__help lead font-weight-bold d-flex align-items-center">
              <Badge
                className="editorformsection__help__button"
                color="warning"
                id={`${panelName}_help`}
                onClick={this.toggleModal}
              >
                {this.context.t("Help")}
              </Badge>
              <Modal
                centered
                fade={false}
                size="lg"
                target={`${panelName}_help`}
                isOpen={this.state.helpModalOpen}
                toggle={this.toggleModal}
              >
                <ModalHeader toggle={this.toggleModal}>
                  {panelTitle}
                </ModalHeader>
                <ModalBody>
                  <div
                    dangerouslySetInnerHTML={{ __html: help || panelName }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.toggleModal}>
                    {this.context.t("Close")}
                  </Button>{" "}
                </ModalFooter>
              </Modal>
            </div>
          )}
        </div>
        <Collapse isOpen={this.props.open}>
          <div className="editorformsection__body">{this.props.children}</div>
        </Collapse>
      </div>
    );
  }
}

/**  define proptype for the 'translation' function  */
EditorFormSection.contextTypes = {
  t: PropTypes.func,
};

export default EditorFormSection;
